import _ from "underscore";
import $ from "jquery";
import AsnDetailStore from '../stores/AsnDetailStore';
import AsnStore from "../stores/AsnStore";
import ServiceStore from "../stores/CmrServiceStore";
import {isBlank} from '../utilities/general';
// {
//   "0": {
//     id: 1,
//     shippingMethod: "parcel"
//   }
// }
export default function AsnSerializer(asn, options={}){
  const self = this;
  asn = _.extend({}, asn);

  self.toJsonWithAsnDetails = function(){
    asn = stampQuoteToAsn(asn);
    asn = stampHolidayPickup(asn);
    asn = stampWeekendPickup(asn);
    asn.asnDetails = getAsnDetails();
    asn.asnShippingPalletStore = getAsnShippingPallets();
    return JSON.stringify(asn);
  }

  self.toJsonNestedIntoPalletsAndCases = function(){
    asn = stampQuoteToAsn(asn);
    asn = stampHolidayPickup(asn);
    asn = stampWeekendPickup(asn);
    let asnDetails = getAsnDetails();
    asn.asnShippingPalletStore = getAsnShippingPallets();
    /** This logic has been newly added to manage switching cases vs pallet while edit the ASN. We use ASN's status to identify
    the newly created cases or pallet ASN **/
    /** copy the necessary information in case we miss from original ASN while switching case or pallet **/
    if(!isBlank(asn.asnId))
    {
      _(asnDetails).map((detail)=>{
        detail.asnId = asn.asnId;
      });
    }

     if(options.includeServices){
      asnDetails = nestServicesForAsnDetails(asnDetails);
      asn = nestServicesForAsn(asn);
    }

    if(AsnStore.isPallet(asn)){
      let palletObjects = origanizeIntoPalletAndCaseObjects(asnDetails);
      asn.palletGroups = palletObjects;
    }else{
      let caseObjects = organizeIntoCaseObjects(asnDetails);
      asn.caseGroups = caseObjects;

      /*  Fix for HB 7904, HB-8171
          commenting out this code because palletgroups is not required for cases. It also causes the issue for cases
          and asd_case_line_no starts from 1 if palletLineNumber is not 1 by default. It breaks sequences for cases. */
      //let palletObjects = origanizeIntoPalletAndCaseObjects(asnDetails);
      //asn.palletGroups = palletObjects;
    }


    return JSON.stringify(asn);
  }


  function nestServicesForAsnDetails(asnDetails){
    return _(asnDetails).map((detail)=>{
      detail.cmr_services = ServiceStore.getServicesViaAsnDetailId(detail.id);
      return detail;
    })
  }

  function nestServicesForAsn(asn){
    asn.cmr_services = ServiceStore.getServicesViaAsnId(asn.id);
    return asn;
  }


  function stampQuoteToAsn(asn){
    const quote = AsnStore.getSelectedQuote(asn);
    if(!!quote){
      asn.quote = {...quote};
    }
    return asn;
  }

  function stampHolidayPickup(asn){
    asn.isPickupDateWeekend = !!AsnStore.getPickupDateWeekend(asn);
    return asn;
  }
  function stampWeekendPickup(asn){
    asn.isPickupDateHoliday = !!AsnStore.getPickupDateHoliday(asn);
    return asn;
  }
  // [
  //   [{
  //     id: 1,
  //     sku: "product-sku-1",
  //     perishable: true,
  //     requiresBatchLot: false,
  //     fragile: true,
  //     barcode: true,
  //     caseLineNumber: 1,
  //     palletLineNumber: 1,
  //     unitsPerCase: 1
  //   },
  //   {
  //     id: 2,
  //     sku: "product-sku-2",
  //     perishable: true,
  //     requiresBatchLot: true,
  //     fragile: false,
  //     barcode: true,
  //     caseLineNumber: 1,
  //     palletLineNumber: 1,
  //     unitsPerCase: 1
  //   }]
  // ]


  function origanizeIntoPalletAndCaseObjects(asnDetails){
    const pallets = AsnDetailStore.organizeIntoPallets(asnDetails);
    const palletObjects = [];
    _(pallets).each((asnDetailSubset, palletIdx)=>{
      const firstAsnDetail = asnDetailSubset[0];
      const palletObject = {};
      palletObject.numberOfPallets = firstAsnDetail.numberOfPallets;
      destructureAsnDetailAndAssign(palletObject, firstAsnDetail);
      // Per Rishish's request, renumber all pallet/caselineNumbers
      // so there is no gaps, regardless of benefits/drawbacks
      reassignKeyValueToObjects(asnDetailSubset, "palletLineNumber", palletIdx + 1);

      palletObject.caseGroups = organizeIntoCaseObjects(asnDetailSubset, {excludeDimensions: true});
      palletObjects.push(palletObject);
    });
    return palletObjects;
  }

  function organizeIntoCaseObjects(asnDetails, {excludeDimensions}={}){
    const cases = AsnDetailStore.organizeIntoCases(asnDetails);
    const caseObjects = [];
    _(cases).each((asnDetailSubset, caseIdx)=>{
      const firstAsnDetail = asnDetailSubset[0];
      const caseObject = {};
      caseObject.numberOfCases = firstAsnDetail.numberOfCases;
      caseObject.declaredValue = firstAsnDetail.declaredValue;
      caseObject.dvlInsideCase = firstAsnDetail.dvlInsideCase;
      caseObject.useCalculatedVal = firstAsnDetail.useCalculatedVal;
      if(!excludeDimensions){
        destructureAsnDetailAndAssign(caseObject, firstAsnDetail);
      }
      reassignKeyValueToObjects(asnDetailSubset, "caseLineNumber", caseIdx + 1);

      caseObject.skus = asnDetailSubset;
      caseObjects.push(caseObject);
    });
    return caseObjects;
  }

  function reassignKeyValueToObjects(arrOfObjs, key, val){
    _(arrOfObjs).each((obj)=>{
      obj[key] = val;
    });
  }


  function destructureAsnDetailAndAssign(target, asnDetail){
    const props = _(asnDetail).pick("asd_package_length", "asd_package_width", "asd_package_height", "asd_package_weight", "asd_tracking_number", "asd_expected_arrival_date");
    _.extend(target, props);
  }


  function getAsnDetails(){
    return AsnDetailStore.where({asnId: asn.id});
  }

  function getAsnShippingPallets(){
    return AsnShippingPalletStore.where({asnId: asn.id});
  }

}

window.AsnSerializer = AsnSerializer;



// WEBPACK FOOTER //
// ./src/serializers/AsnSerializer.js